import React, { ReactNode, useEffect } from "react";

import { useRouter } from "next/router";

import { LoadingPage } from "~/components/common/LoadingPage/LoadingPage";
import { useAuth } from "~/hooks/auth/useAuth";

interface Props {
  children: ReactNode;
}

export const RequireAuthWrapper = ({ children }: Props): React.ReactElement => {
  const { loadingCurrentUser, user } = useAuth();

  const router = useRouter();

  useEffect(() => {
    if (!loadingCurrentUser && !user && router.pathname !== "/") {
      router.push("/");
    }
  }, [router, user, loadingCurrentUser]);

  // show loading state while we get the current user
  // we also need loading state for !user, for any temporary state after the user has loaded
  // but we haven't fully redirected away yet
  if (loadingCurrentUser || !user) {
    return <div></div>;
    // <LoadingPage />;
  }

  return <>{children}</>;
};
